// prettier-ignore
export const fallbackImg ="data:image/png;base64,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"

const constents = {
  gutterResponsive: [
    { xs: 8, sm: 16, md: 24, lg: 30 },
    { xs: 8, sm: 16, md: 24, lg: 30 },
  ],
  dateFormat: 'YYYY-MM-DD',
  dateFormatHM: 'YYYY-MM-DD HH:MM A',
  rulesRequeried: [
    {
      required: true,
    },
  ],
};

export const bloodGroups = [
  {
    value: 'A Positive',
    english: 'A Positive',
    arabic: 'فصيلة الدم A إيجابية',
  },
  { value: 'A Negative', english: 'A Negative', arabic: 'فصيلة الدم A سلبية' },
  {
    value: 'B Positive',
    english: 'B Positive',
    arabic: 'فصيلة الدم B إيجابية',
  },
  { value: 'B Negative', english: 'B Negative', arabic: 'فصيلة الدم B سلبية' },
  {
    value: 'AB Positive',
    english: 'AB Positive',
    arabic: 'فصيلة الدم AB إيجابية',
  },
  {
    value: 'AB Negative',
    english: 'AB Negative',
    arabic: 'فصيلة الدم AB سلبية',
  },
  {
    value: 'O Positive',
    english: 'O Positive',
    arabic: 'فصيلة الدم O إيجابية',
  },
  { value: 'O Negative', english: 'O Negative', arabic: 'فصيلة الدم O سلبية' },
];

export const FakeInvoice = {
  owner: 'admin2@test.com',
  docstatus: 0,
  idx: 0,
  naming_series: 'ACC-SINV-.YYYY.-',
  patient: 'P-000005',
  patient_name: 'لما الماضي',
  custom_patient_nationality: '169',
  customer: 'لما الماضي',
  ref_practitioner: 'HLC-PRAC-2024-00001',
  customer_name: 'لما الماضي',
  company: 'Shaqaf',
  company_tax_id: '111122112',
  posting_date: '2024-09-27',
  posting_time: '16:24:18.353148',
  set_posting_time: 0,
  custom_payment_method: '8',
  is_pos: 0,
  is_consolidated: 0,
  is_return: 1,
  return_against: 'ACC-SINV-2024-00045',
  update_outstanding_for_self: 0,
  update_billed_amount_in_sales_order: 0,
  update_billed_amount_in_delivery_note: 1,
  is_debit_note: 0,
  currency: 'SAR',
  conversion_rate: 1.0,
  selling_price_list: 'Standard Selling',
  price_list_currency: 'SAR',
  plc_conversion_rate: 1.0,
  ignore_pricing_rule: 0,
  update_stock: 0,
  set_warehouse: '',
  total_qty: -1.0,
  total_net_weight: 0.0,
  base_total: -100.0,
  base_net_total: -100.0,
  total: -100.0,
  total_insurance_coverage_amount: 0.0,
  patient_payable_amount: 0.0,
  net_total: -100.0,
  base_total_taxes_and_charges: -15.0,
  total_taxes_and_charges: -15.0,
  base_grand_total: -115.0,
  base_rounding_adjustment: 0.0,
  base_rounded_total: -115.0,
  base_in_words: 'SAR One Hundred And Fifteen only.',
  grand_total: -115.0,
  rounding_adjustment: 0.0,
  use_company_roundoff_cost_center: 0,
  rounded_total: -115.0,
  in_words: 'SAR One Hundred And Fifteen only.',
  total_advance: 0.0,
  outstanding_amount: 0.0,
  disable_rounded_total: 0,
  apply_discount_on: 'Grand Total',
  base_discount_amount: 0.0,
  is_cash_or_non_trade_discount: 0,
  additional_discount_percentage: 0.0,
  discount_amount: 0.0,
  other_charges_calculation:
    '<div class="tax-break-up" style="overflow-x: auto;">\n\t<table class="table table-bordered table-hover">\n\t\t<thead>\n\t\t\t<tr>\n\t\t\t\t\n\t\t\t\t\t\n\t\t\t\t\t\t<th class="text-left">Item</th>\n\t\t\t\t\t\n\t\t\t\t\n\t\t\t\t\t\n\t\t\t\t\t\t<th class="text-right">Taxable Amount</th>\n\t\t\t\t\t\n\t\t\t\t\n\t\t\t\t\t\n\t\t\t\t\t\t<th class="text-right">VAT 15% - S</th>\n\t\t\t\t\t\n\t\t\t\t\n\t\t\t</tr>\n\t\t</thead>\n\t\t<tbody>\n\t\t\t\n\t\t\t\t<tr>\n\t\t\t\t\t<td>hhh</td>\n\t\t\t\t\t<td class="text-right">\n\t\t\t\t\t\t\n\t\t\t\t\t\t\tر.س 100.00\n\t\t\t\t\t\t\n\t\t\t\t\t</td>\n\t\t\t\t\t\n\t\t\t\t\t\t\n\t\t\t\t\t\t\n\t\t\t\t\t\t\t<td class="text-right">\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t(15.0%)\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\tر.س 15.00\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t</td>\n\t\t\t\t\t\t\n\t\t\t\t\t\n\t\t\t\t</tr>\n\t\t\t\n\t\t</tbody>\n\t</table>\n</div>',
  total_billing_hours: 0.0,
  total_billing_amount: 0.0,
  base_paid_amount: 0.0,
  paid_amount: 0.0,
  base_change_amount: 0.0,
  change_amount: 0.0,
  allocate_advances_automatically: 0,
  only_include_allocated_payments: 0,
  write_off_amount: 0.0,
  base_write_off_amount: 0.0,
  write_off_outstanding_amount_automatically: 0,
  redeem_loyalty_points: 0,
  loyalty_points: 0,
  loyalty_amount: 0.0,
  dont_create_loyalty_points: 0,
  contact_person: 'لما الماضي-لما الماضي',
  contact_display: 'لما الماضي',
  contact_mobile: '+966553919866',
  territory: 'All Territories',
  company_trn: '111122112',
  ignore_default_payment_terms_template: 0,
  debit_to: 'Debtors - S',
  is_opening: 'No',
  amount_eligible_for_commission: -100.0,
  commission_rate: 0.0,
  total_commission: 0.0,
  group_same_items: 0,
  select_print_heading: 'Credit Note',
  language: 'en',
  status: 'Draft',
  customer_group: 'All Customer Groups',
  is_internal_customer: 0,
  is_discounted: 0,
  repost_required: 0,
  doctype: 'Sales Invoice',
  taxes: [
    {
      owner: 'admin2@test.com',
      docstatus: 0,
      idx: 1,
      charge_type: 'On Net Total',
      account_head: 'VAT 15% - S',
      description: 'VAT 15% - S',
      included_in_print_rate: 0,
      included_in_paid_amount: 0,
      cost_center: 'Main - S',
      rate: 15.0,
      tax_amount: -15.0,
      total: -115.0,
      tax_amount_after_discount_amount: -15.0,
      base_tax_amount: -15.0,
      base_total: -115.0,
      base_tax_amount_after_discount_amount: -15.0,
      item_wise_tax_detail: '{"hhh":[15.0,-15.0]}',
      dont_recompute_tax: 0,
      parentfield: 'taxes',
      parenttype: 'Sales Invoice',
      doctype: 'Sales Taxes and Charges',
      __islocal: 1,
      __unsaved: 1,
    },
  ],
  payments: [],
  advances: [],
  timesheets: [],
  items: [
    {
      owner: 'admin2@test.com',
      docstatus: 0,
      idx: 1,
      has_item_scanned: 0,
      item_code: 'hhh',
      item_name: 'hhh',
      description: 'hhh',
      is_zero_rated: 0,
      is_exempt: 0,
      item_group: 'All Item Groups',
      qty: -1.0,
      stock_uom: 'Nos',
      uom: 'Nos',
      conversion_factor: 1.0,
      stock_qty: -1.0,
      price_list_rate: 100.0,
      base_price_list_rate: 100.0,
      margin_type: '',
      margin_rate_or_amount: 0.0,
      rate_with_margin: 0.0,
      discount_percentage: 0.0,
      discount_amount: 0.0,
      base_rate_with_margin: 0.0,
      rate: 100.0,
      amount: -100.0,
      base_rate: 100.0,
      base_amount: -100.0,
      stock_uom_rate: 0.0,
      is_free_item: 0,
      coverage_rate: 0.0,
      coverage_qty: 0.0,
      coverage_percentage: 0.0,
      insurance_coverage_amount: 0.0,
      grant_commission: 1,
      net_rate: 100.0,
      net_amount: -100.0,
      base_net_rate: 100.0,
      base_net_amount: -100.0,
      delivered_by_supplier: 0,
      income_account: 'Earnest Money - S',
      is_fixed_asset: 0,
      expense_account: 'Cost of Goods Sold - S',
      enable_deferred_revenue: 0,
      weight_per_unit: 0.0,
      total_weight: 0.0,
      warehouse: 'Stores - S',
      incoming_rate: 0.0,
      allow_zero_valuation_rate: 0,
      item_tax_rate: '{}',
      actual_batch_qty: 0.0,
      actual_qty: 0.0,
      sales_invoice_item: '6188df44d0',
      delivered_qty: 0.0,
      cost_center: 'Main - S',
      page_break: 0,
      parentfield: 'items',
      parenttype: 'Sales Invoice',
      doctype: 'Sales Invoice Item',
      __islocal: 1,
      __unsaved: 1,
    },
  ],
  sales_team: [],
  payment_schedule: [
    {
      owner: 'admin2@test.com',
      docstatus: 0,
      idx: 1,
      due_date: '2024-09-30',
      invoice_portion: 100.0,
      discount_type: 'Percentage',
      discount: 0.0,
      payment_amount: -115.0,
      outstanding: 115.0,
      paid_amount: 0.0,
      discounted_amount: 0.0,
      base_payment_amount: 115.0,
      parentfield: 'payment_schedule',
      parenttype: 'Sales Invoice',
      doctype: 'Payment Schedule',
      __islocal: 1,
      __unsaved: 1,
    },
  ],
  pricing_rules: [],
  packed_items: [],
  __islocal: 1,
  __onload: {
    load_after_mapping: true,
  },
  __unsaved: 1,
};

export default constents;
